import { useOfferingType } from '@/hooks/useOfferingType';
import { ProductContentReview } from './ContentReviewDashboard.product';
import { ServiceContentReview } from './ContentReviewDashboard.service';

/**
 * Thin router that delegates to the correct content review view
 * based on the selected site's offering_type.
 *
 * - 'product' (default) -> ProductContentReview  (original 1,350-line component)
 * - 'service'           -> ServiceContentReview  (service article review with quality checklist)
 * - 'mixed'             -> both stacked
 */
export default function ContentReviewDashboard() {
  const offeringType = useOfferingType();

  switch (offeringType) {
    case 'service':
      return <ServiceContentReview />;
    case 'mixed':
      return (
        <div className="space-y-8">
          <div>
            <h2 className="text-lg font-semibold mb-4">Service Content Review</h2>
            <ServiceContentReview />
          </div>
          <div>
            <h2 className="text-lg font-semibold mb-4">Product Content Review</h2>
            <ProductContentReview />
          </div>
        </div>
      );
    case 'product':
    default:
      return <ProductContentReview />;
  }
}
